import type { WorkflowProductDescriptor } from "./types";

const registry = new Map<string, WorkflowProductDescriptor>();

export function registerWorkflowProduct(
  descriptor: WorkflowProductDescriptor,
): WorkflowProductDescriptor {
  registry.set(descriptor.productKey, descriptor);
  return descriptor;
}

export function getWorkflowProduct(
  productKey: string,
): WorkflowProductDescriptor | undefined {
  return registry.get(productKey);
}
